import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFormPentagon: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-0-stroke-1.5-IconFormPentagon"><Path d="M11.6617 1.58157C11.9095 1.45639 12.2101 1.47709 12.44 1.64407L21.7135 8.3804C21.9759 8.57142 22.0862 8.91048 21.9859 9.21927L18.4439 20.1206C18.3434 20.4292 18.0546 20.638 17.7301 20.6382H6.26914C5.94454 20.6382 5.65594 20.4292 5.55527 20.1206L2.01328 9.21927C1.91296 8.91029 2.02292 8.57135 2.28574 8.3804L11.5592 1.64407L11.6617 1.58157Z" fill="currentColor"/></CentralIconBase>;
});

export default IconFormPentagon;
